export default {
  'statusCodes.Status_code': 'Status code',
  'statusCodes.Total': 'Total',
  'statusCodes.title': 'Status code report',
  'statusCodes.subTitle': '(Please view the data according to utc+8.)',
  'statusCodes.Request': 'Request',
};
